import type { AloftPrice } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra
import { PopoverBody } from '@aloft/toolkit-sui/chakra';

import type { AdjSalePriceLineItem } from './adjSalePriceBreakdownLineItems.ts';

type Props = {
  lineItems: AdjSalePriceLineItem[];
  netAdjustmentLabel: string;
  netAdjustment: AloftPrice;
};

export const AdjSalePriceBreakdownContent = ({
  lineItems,
  netAdjustmentLabel,
  netAdjustment,
}: Props) => (
  <PopoverBody padding="12px 16px">
    <Flex flexDirection="column" gap="8px">
      {lineItems.map((item) => (
        <Flex key={item.label} justifyContent="space-between" gap="16px">
          <Typography variant="body2" color="textPrimary">
            {item.label}
          </Typography>
          <Typography variant="h5" color="textPrimary">
            {item.adjustment.toString(true)}
          </Typography>
        </Flex>
      ))}
      <Flex
        justifyContent="space-between"
        gap="16px"
        paddingTop="8px"
        __dangerDoNotUseSx={{ borderTop: '1px solid rgba(0,0,0,0.1)' }}
      >
        <Typography variant="body2" color="textPrimary">
          {netAdjustmentLabel}
        </Typography>
        <Typography variant="h5" color={netAdjustment.unitAmount < 0 ? 'textError' : 'textPrimary'}>
          {netAdjustment.toString(true)}
        </Typography>
      </Flex>
    </Flex>
  </PopoverBody>
);
